import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  label: {
    defaultMessage: 'Data Source',
    id: '66WFLS',
    description: 'Label for data source input',
  },
});
